<template>
    <div>
        <DCard
            :title="__('contracts.contract_upload.messages.upload_new_contracts')"
            padding
        >
            <DFormRow
                :label="__('contracts.contract_upload.upload_form.name')"
                is-required
            >
                <DInput
                    id="contracts-upload-name"
                    v-model="form.name"
                    requried
                    :invalid-feedback="errors.name"
                />
            </DFormRow>
            <div class="file-section">
                <DFormRow
                    :label="__('contracts.contract_upload.upload_form.file')"
                    is-required
                    class="contracts-upload-file"
                >
                    <DFileInput
                        id="pcontracts-upload-file"
                        :custom="true"
                        :multiple="false"
                        :invalid-feedback="errors.file"
                        :file-with-errors="fileWithErrors"
                        @change="addFile"
                        @reset-file-with-errors="resetFileWithErrors"
                    />
                    <p v-if="form.file">
                        {{ form.file.name }}
                    </p>
                </DFormRow>
                <DButton
                    icon="download"
                    :label="__('contracts.contract_upload.download_csv')"
                    @click="downloadCsv"
                />
            </div>
        </DCard>
        <DCard
            v-if="errors.errorMessage"
            :title="__('contracts.contract_upload.messages.file_errors')"
            padding
            class="mt-3"
        >
            <DRow
                v-for="(error, index) in errors"
                :key="index"
            >
                <DFormRow
                    v-if="error.length > 0 && index !== 'errorMessage'"
                    :label="__(`contracts.contract_upload.messages.${index}`)"
                >
                    {{ error }}
                </DFormRow>
            </DRow>
        </DCard>
    </div>
    <DFormControls
        :dirty="form.isDirty"
        :submit-message="__('contracts.contract_upload.preview')"
        submit-icon="eye"
        :cancel-route="cancelRoute"
        @submit="submitForm"
    />
</template>

<script setup>
import { route } from '~@/Composables/route'
import { useForm } from '@inertiajs/vue3'
import { __ } from '~@/Composables/translation'
import { computed, ref } from 'vue'

defineProps({
    errors: {
        type: Object,
        default: () => {
            return {}
        }
    }
})

const form = useForm({
    name: null,
    file: null
})

const downloadCsv = () => {
    const link = document.createElement('a')
    link.href = route('contracts.contract-upload.download-template')
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
}

const fileWithErrors = ref(false)

function addFile (fileList) {
    form.file = fileList[0]
}

function submitForm () {
    form.post(route('contracts.contract-upload.upload'), {
        onError: () => {
            form.file = null
            fileWithErrors.value = true
        }
    })
}

function resetFileWithErrors () {
    fileWithErrors.value = false
}

const cancelRoute = computed(() => {
    return route('contracts.contract-upload.index')
})
</script>

<style scoped lang="scss">
    .file-section {
        margin-bottom: 25px;
    }
</style>
